import moment from "moment";
import { useLmcUserView } from "../../../../../contexts/AuthContext";
import { useTranslation } from "react-i18next";

const LmcRewardMessage = ({
  messages = [],
}: {
  messages: { date: string; value: string }[] | [];
}) => {
  const {
    state: { entity },
  } = useLmcUserView();

  const { t } = useTranslation("clientView");
  return (
    <div className="w-full py-4">
      {messages?.length > 0 ? (
        messages
          ?.sort(
            (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
          )
          ?.map((item, index) => {
            if (entity.process_data?.options.nb_history_message > index)
              return (
                <div key={index} className="p-4 border-b border-gray-800">
                  <h4 className="text-gray-200 text-lg font-semibold font-figtree leading-7 break-words">
                    {item.value}
                  </h4>
                  <p className="text-gray-400 text-sm font-normal font-figtree leading-tight">
                    {moment(item.date).format("ll")}
                  </p>
                </div>
              );
            else return null;
          })
      ) : (
        <div className="text-gray-200 text-base font-figtree leading-7 text-center">
          {t("lmcUser.key66")}
        </div>
      )}
    </div>
  );
};

export default LmcRewardMessage;
